import { render, staticRenderFns } from "./country_select.vue?vue&type=template&id=ddec2144&scoped=true"
import script from "./country_select.vue?vue&type=script&lang=js"
export * from "./country_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddec2144",
  null
  
)

export default component.exports